// src/features/summary/summaryService.js
import api from "../../api/api";

/**
 * Ambil data summary counts dari endpoint /summary/counts
 * @returns {Promise<Object>} - Data summary dari API
 */
const getSummaryCounts = async () => {
  const response = await api.get("/summary/counts");
  return response.data;
};

const summaryService = {
  getSummaryCounts,
};

export default summaryService;
